import React from 'react';
import styles from './Badge.module.css';
import classNames from 'classnames';

type BadgeContainerProps = React.PropsWithChildren<{}>;
const BadgeContainer: React.FC<BadgeContainerProps> = ({ children }) => {
	return <div className={classNames(styles.BadgeContainer, {})}>{children}</div>;
};

type BadgeType = 'alert' | 'info' | 'warning' | 'notify';

type BadgeContentProps = React.PropsWithChildren<{
	type?: BadgeType;
	small?: boolean;
	children?: string | number;
}>;
const BadgeContent: React.FC<BadgeContentProps> = ({ children, type = 'info', small }) => {
	if (React.Children.count(children)) {
		return (
			<div
				className={classNames(styles.BadgeContent, {
					[styles.info]: type === 'info',
					[styles.alert]: type === 'alert',
					[styles.notify]: type === 'notify',
					[styles.small]: small
				})}
			>
				{children}
			</div>
		);
	}
	return null;
};

export type BadgeProps = React.PropsWithChildren<{
	content?: string | number;
	small?: boolean;
	type?: BadgeType;
}>;

export const Badge: React.FC<BadgeProps> = ({ children, content, small, type }) => {
	if (React.Children.count(children)) {
		return (
			<BadgeContainer>
				{children}
				<BadgeContent small={small} type={type}>
					{content}
				</BadgeContent>
			</BadgeContainer>
		);
	}

	return (
		<BadgeContent small={small} type={type}>
			{content}
		</BadgeContent>
	);
};
